import confetti from 'canvas-confetti';

export const triggerChrisMorganAwardCelebration = () => {
  // Golden/architectural themed confetti
  const duration = 3000;
  const animationEnd = Date.now() + duration;
  
  // Custom colors for architectural excellence
  const colors = ['#FFD700', '#FFA500', '#FF6347', '#4169E1', '#32CD32'];

  const randomInRange = (min: number, max: number) => {
    return Math.random() * (max - min) + min;
  };

  const interval = setInterval(() => {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      clearInterval(interval);
      return;
    }

    const particleCount = 50 * (timeLeft / duration);

    // Burst from left side
    confetti({
      particleCount,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.8 },
      colors,
      shapes: ['star', 'circle'],
      scalar: 1.2,
      drift: 1,
      gravity: 0.8,
      ticks: 200
    });

    // Burst from right side  
    confetti({
      particleCount,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.8 },
      colors,
      shapes: ['star', 'circle'],
      scalar: 1.2,
      drift: -1,
      gravity: 0.8,
      ticks: 200
    });

    // Center firework
    confetti({
      particleCount: 30,
      angle: randomInRange(55, 125),
      spread: randomInRange(50, 70),
      origin: { x: randomInRange(0.1, 0.9), y: randomInRange(0.1, 0.4) },
      colors,
      shapes: ['star'],
      scalar: 1.5,
      gravity: 0.6,
      ticks: 300
    });
  }, 250);

  // Epic finale
  setTimeout(() => {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors,
      shapes: ['star', 'circle'],
      scalar: 2,
      gravity: 0.5,
      ticks: 400
    });
  }, 1000);
};

// Special celebration for when completing the full tour with awards
export const triggerMasterArchitectCelebration = () => {
  const count = 200;
  const defaults = {
    origin: { y: 0.7 },
    colors: ['#FFD700', '#FFA500', '#FF6347', '#4169E1', '#32CD32'],
    shapes: ['star'],
    scalar: 2
  };

  function fire(particleRatio: number, opts: any) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio)
    });
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });

  fire(0.2, {
    spread: 60,
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
};